import { isNotNil } from "es-toolkit";
import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const FinanceDisbursementRoutes = defineRoute({
    record: {
        route: {
            path: "/finance-disbursement",
            component: () => loadView(import("./FinanceDisbursementTable.vue")),
        },
    },
    create: {
        route: {
            path: "/finance-disbursement/create/:accountId?",
            component: () => loadView(import("./FinanceDisbursementCreate.vue")),
        },
        build(params: { accountId?: string }) {
            if (isNotNil(params.accountId)) {
                return `/finance-disbursement/create/${params.accountId}`;
            }

            return "/finance-disbursement/create";
        },
    },
    detail: {
        route: {
            path: "/finance-disbursement/detail/:id",
            component: () => loadView(import("./FinanceDisbursementDetail.vue")),
        },
        build(id: string) {
            return `/finance-disbursement/detail/${id}`;
        },
    },
});
